export enum DeviceType {
  tablet = 0,
  gateway = 1,
  sensor = 2,
}

export enum SensorType {
  SENSOR_CV = 10,
  SENSOR_CV_EXPIRY = 3,
  SENSOR_WEIGHT = 11,
  SENSOR_EXPIRY = 12,
  SENSOR_HANGER = 13,
}
